export const defaultState = {
  registeredUnemployedPeople: [],
};
